// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10jBO","select":"styles_select__2CsYd"};